/**
 * AlertasTab — lista de grupos/conversas de alerta da infraestrutura.
 *
 * Extraído do ChatHome original (Task 9). Contém o corpo completo:
 * busca, filtragem e listagem de conversas via useConversations().
 */
import { Box, Loader, Stack, Text, TextInput } from '@mantine/core'
import { IconMessages, IconSearch } from '@tabler/icons-react'
import { useState, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useConversations } from '@/hooks/useChat'
import { EmptyState } from '@/components/ui/EmptyState'
import { ChatListRow } from './ChatListRow'

export default function AlertasTab() {
  const { data, isLoading } = useConversations()
  const navigate = useNavigate()
  const [search, setSearch] = useState('')

  const filtered = useMemo(() => {
    const base = (data ?? []).slice().sort((a, b) => {
      const ta = a.last_message_at ? new Date(a.last_message_at).getTime() : 0
      const tb = b.last_message_at ? new Date(b.last_message_at).getTime() : 0
      return tb - ta
    })
    if (!search.trim()) return base
    const q = search.trim().toLowerCase()
    return base.filter(
      (c) =>
        c.title.toLowerCase().includes(q) ||
        c.client.toLowerCase().includes(q),
    )
  }, [data, search])

  return (
    <Box style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      {/* Cabeçalho */}
      <Box px="md" pt="md" pb="xs" style={{ flexShrink: 0 }}>
        <Text fw={700} size="lg" mb="xs">
          Alertas
        </Text>
        <TextInput
          placeholder="Buscar por título ou cliente…"
          leftSection={<IconSearch size={16} />}
          value={search}
          onChange={(e) => setSearch(e.currentTarget.value)}
          aria-label="Buscar alertas"
        />
      </Box>

      {/* Corpo */}
      <Box style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', minHeight: 0 }}>
        {isLoading && (
          <Stack align="center" pt="xl">
            <Loader size="sm" color="inovareTeal" />
          </Stack>
        )}

        {!isLoading && (data?.length ?? 0) === 0 && (
          <EmptyState
            icon={IconMessages}
            title="Nenhuma conversa ainda"
            description="Os grupos de alerta da sua infraestrutura aparecerão aqui."
            size="md"
          />
        )}

        {!isLoading && filtered.length === 0 && (data?.length ?? 0) > 0 && (
          <Box px="md" pt="md">
            <Text c="dimmed" size="sm" ta="center">
              Nenhuma conversa encontrada para "{search}".
            </Text>
          </Box>
        )}

        {filtered.map((conversation) => (
          <ChatListRow
            key={conversation.id}
            conversation={conversation}
            onClick={() => navigate(`/chat/${conversation.id}`)}
          />
        ))}
      </Box>
    </Box>
  )
}
